<div [formGroup]="formGroupReference">
  <stx-autocomplete-single-select
    data-testid="select-group-by-scope"
    labelKey="reports.filters.group_by_scope.label"
    [formControlName]="controlName"
    [itemList]="scopeOptions"
  ></stx-autocomplete-single-select>
</div>
